import { shape, string, bool, number } from 'prop-types';

const seller = shape({
    username: string.isRequired,
    achievement: number.isRequired,
    is_pro: bool,
    has_profile_photo: bool,
    profile_photo: string
});

export default seller;
